export default "__VITE_ASSET__qM$eW9Dx__"